export const environment = {
  mobileBreakpoint: "600px",
  production: true,
  teamAssetsUrl: "https://realmadrid-static.geographica.gs",
  teamUrl:
    "https://publish-p47754-e237306.adobeaemcloud.com/content/dam/common/statics/public-content/badge/basket",
  playerUrl: "https://publish-p47754-e237306.adobeaemcloud.com/players/basket",
  carto: {
    envPrefix: "",
    tablePreffix: "carto-ps-realmadrid-eu-pro.pro.",
    baseUrl: "https://gcp-europe-west1.api.carto.com/v3/sql",
    connection: "pro_read_app",
    public_access_token:
      "eyJhbGciOiJIUzI1NiJ9.eyJhIjoiYWNfYnkzNzdhNTEiLCJqdGkiOiJjZTIxOTQxYSJ9.UFI2HR2UtWSK3LhA4nltfofbgmT1I33KLjMXfKXsYUk",
  },
};
